import StyledWrapper from "./style";
import { ApplicantDataType } from "./types_Applicants"
import { maritalStatuses, sexs, nationalities } from "../../utils/dataOptionsUsers";
import { PhoneNumber } from "../../utils/phoneNumber";

//TODO: ARREGLAR LOS NACIONALITY POR NATIONALITY 
type applicantProps = {
  employee: ApplicantDataType & { nationality: string, maritalStatus: string } | undefined;
}

const EmployeeData = (props: applicantProps) => {
  let employee = props?.employee
  return (
    <>
      <StyledWrapper.DatosContainer>
        <StyledWrapper.InfoGrouping>
          <StyledWrapper.InfoContainer>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Apellido y Nombre</StyledWrapper.Header>
              <StyledWrapper.SubHeader>{employee?.name || "Pendiente"}</StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Dni o pasaporte</StyledWrapper.Header>
              <StyledWrapper.SubHeader>{employee?.DNI || "Pendiente"}</StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.InfoContainer>

          <StyledWrapper.InfoContainer>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Nacionalidad</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {nationalities.find(
                  element => employee?.nationality === element.value
                )?.name || employee?.nationality || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Estado civil</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {maritalStatuses.find(element => element.value === employee?.maritalStatus)?.name
                  || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.InfoContainer>

          <StyledWrapper.SingleContainerRight>

          <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Cuil</StyledWrapper.Header>
              <StyledWrapper.SubHeader>{employee?.cuil || "Pendiente"}</StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Teléfono</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {(employee?.phoneNumber && PhoneNumber(employee?.phoneNumber)) || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.SingleContainerRight>
        </StyledWrapper.InfoGrouping>

        <StyledWrapper.InfoGrouping>
          <StyledWrapper.InfoContainer>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Fecha de nacimiento</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
               { employee?.birthDate || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.InfoContainer>

          <StyledWrapper.InfoContainer>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Sexo</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {sexs.find(element => element.value === employee?.sex)?.name
                  || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Género</StyledWrapper.Header>
              <StyledWrapper.SubHeader>{employee?.gender || "Pendiente"}</StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.InfoContainer>

          <StyledWrapper.InfoContainer>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>E-mail</StyledWrapper.Header>
              <StyledWrapper.SubHeader>{employee?.email || "Pendiente"}</StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.InfoContainer>
        </StyledWrapper.InfoGrouping>
      </StyledWrapper.DatosContainer>
    </>
  );
};
export default EmployeeData;
